import React from 'react';
import './SubOfficeList.scss';
import { ContactUsData } from '../../../ContactUs.types';
import { useWinSize } from '@contexts/WinSizeContext';
import { Accordion } from '@components/Accordion';
import { ContactCard } from './ContactCard';

export interface SubOfficeListProps {
  data: ContactUsData;
}

export const SubOfficeList = ({ data }: SubOfficeListProps) => {
  if (!data || !data.SubOffices) return null;

  const { isMobile } = useWinSize();

  return (
    <section className='c-sub-office-list'>
      {Object.entries(data.SubOffices).map(([key, value = []], index) => {
        // array-like values are the ones with offices
        if (!(value && Array.isArray(value))) return null;
        const officeType = key.split('|');
        const title = officeType[0];

        if (!isMobile) {
          return (
            <div key={key} className='l-content l-page-center'>
              <div className='l-section l-section-100'>
                <div className='c-l-contact-section'>
                  <h3 className='c-contact-group-title'>{title}</h3>
                </div>
              </div>
              {value.map((office, index) => (
                <div key={index} className='l-section l-section-25'>
                  <ContactCard office={office} />
                </div>
              ))}
            </div>
          );
        }

        return (
          <Accordion.Container key={key} className='is-related'>
            <Accordion.Section
              index={+key}
              tab={{ id: 1, name: title }}
              url={null}
              isLight
              accordionBlockSelector='.c-sub-office-list'
              // 0 index is $id
              isOpen={index === 1}
            >
              {value.map((office, index) => (
                <div key={index} className='l-section l-section-25'>
                  <ContactCard office={office} />
                </div>
              ))}
            </Accordion.Section>
          </Accordion.Container>
        );
      })}
    </section>
  );
};
